import React, { Component } from 'react';
import moment from 'moment';
import config from '../../config';
import ApiClient from '../../libs/apiClient';
import $ from "jquery";
import { AreYouAgreeModal, BatchSelectionModal, BreadCumb, CashCutModal, GeneralFunctions, InitialCashModal, NavBar, NewCustomerModal, PdfViewer, TimeOut } from '../../components';
import { Anticipo, CURRENCY, DISPATCH_ID, FORMAT_NUMBER, points_Card, SERVICE_RESPONSE, SYMBOL } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import { NewItem, NewOrderSales, PointsCardModel } from '../../components/NewOrder';
import packageJson from '../../../package.json';
import socketService from '../../libs/sockets/SocketService';

const _generalFunctions = new GeneralFunctions();
global.appVersion = packageJson.version;
const currentVersion = global.appVersion;
const EMAIL_FORMAT_REGEX = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

let apiClient = ApiClient.getInstance()
class DeliverView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            TODAY: moment(new Date()).format('YYYY-MM-DD'),
            BankAccounts: [],
            idWorkShift: "",
            lastDaySession: false,
            showCashCutModal: false,
            showInitialCashModal: false,
            cashCut: {},
            totalCashCut: 0,
            TotalAmountSales: 0,
            numSalesCashCut: 0,
            extraPaymentsCashCut: {},
            moneyOuts: [],
            moneyEntries: [],
            series: [],
            LimitLinesBO: null,
            CounterRol: null,
            AvailablePayments: [],
            writeAccess: false,
            FlagPayWithSantander: false,
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),

            //FROM POSVIEW
            newOrderModel: new NewOrderSales(),
            checkboxDataTables: (new Map()),
            EditDiscount: false,
            EditPrice: false,
            creditNotesPay: false,
            creditPay: false,
            itemSearch: "",
            requireInvoice: false,
            taxList: [],
            objType: "",
            suggestions: [],
            suggestionsCopy: [],
            ShowWithStock: false,
            showSearchModal: false,
            showBillModal: false,
            showBatchSelectionModal: false,
            docsToPrint: [],
            typeDocPrint: '',
            ordersToAction: 0,
            EnableEditButton: false,
            showPDFViewer: false,
            ShowExtraActions: false,

            //DOCS TO PRINT
            initialDate: moment(new Date()).format("YYYY-MM-DD"),
            finalDate: moment(new Date()).format("YYYY-MM-DD"),
            ordersSearchModel: {
                CardCode: '',
                DocNum: ''
            },
            ordersDocs: [],
            editableMode: false,
            EditableDocModel: {
                street: '',
                county: '',
                city: '',
                block: '',
                zipCode: '',
                rfc: '',
                shipStreet: '',
                shipCounty: '',
                shipCity: '',
                shipBlock: '',
                shipZipCode: ''
            },
            detailDoc: {},
            groupNumList: [],
            extraDocsToShow: [],
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            printhide: true,
            PointsCardModel: new PointsCardModel(),
            ShowExtraActions: false,
            indexTypeDocShow: 0,
            pedido: '',
            showRefundModal: false,
            itemSelected: {},
            itsCancelCFDIAvailable: false,
            relatedDocs: [],
            showAreYouAgreeModal_Join_e_Wallet: false,
            showNewCustomerModal: false,
            objCharge: {},
            ReturnedBlindCut: [],
            blindCashCut: true,
            ReturnedBlindCut: [],
            bankOptions: [],


        }
    }

    componentDidMount = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, TODAY } = this.state;
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let newArraySeries = [];
        let seriesUsers = user.U_FMB_ValidateSeriesORCT.split("|");
        let dataSerie = {
            docType: '24',
            docSubType: '--'
        };
        this._handelBack();
        let seriesResponse = await apiClient.getSeries(dataSerie);
        if (!seriesResponse.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: "Error inesperado al consultar las series de su sucursal para cobranza. Contacte con su administrador y recargue la pagina" });
            return;
        }
        seriesUsers.map(serieUser => {
            seriesResponse.data.map(serieResponse => {
                if (serieResponse.Series === Number(serieUser)) {
                    newArraySeries.push(serieResponse);
                }
            })
        })

        if (newArraySeries.length === 0) {
            showAlert({ type: 'warning', timeOut: 5000, message: "El usuario no tiene serie permitida de escritura" });
            return;
        }
        this.GetBankAccounts();
        await this.CheckWorkSession();
        newOrderModel.SerieArray = newArraySeries;

        let PaymentMethods = [];
        if (user.Branch.PaymentMethods) {
            for (let index = 0; index < user.Branch.PaymentMethods.length; index++) {
                const element = user.Branch.PaymentMethods[index];
                if (Number(element.type) !== 4 && (Number(element.TipoUso) === 2 || Number(element.TipoUso) === 3)) {
                    PaymentMethods.push(element);
                }
            }
        }
        PaymentMethods.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));

        ///permisions
        const modules = user.U_FMB_Modulos ? JSON.parse(user.U_FMB_Modulos) : null
        let writeAccess = false;
        if (modules.payments) {
            writeAccess = modules.payments.Wr
        }
        await this.setState({
            newOrderModel,
            series: newArraySeries,
            LimitLinesBO: user.Branch.LimitLines || null,
            CounterRol: user.U_FMB_CounterRol || null,
            AvailablePayments: PaymentMethods || [],
            writeAccess
        });

        if (TODAY.valueOf() <= '2023-07-20') {
            showAlert({ type: 'info', message: 'HOLA USUARIO, CON ESTA NUEVA ACTUALIZACIÓN NO PUEDES CREAR UN DOCUMENTO DE COBRANZA CON DISTINTOS METODOS DE PAGO, OSEASE QUE NO PUEDES MEZCLAR DOCUMENTOS TIPO PPD Y PUE. AL IGUAL NO PUEDES MEZCLAR DOCUMENTOS DE 16% CON 8% (CLICK PARA DESAPARECER ESTE AVISO)', timeOut: 90000 });
        }
        this.DeterminatePayWithTerminalPermission();
        await this.searchBanksOptions();
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    GetBankAccounts = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.getCuentaBancosList();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        this.setState({ BankAccounts: responseApi.data || [] })
    };

    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);
        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                if (responseApi.data.NotCashCut === true) {
                    showAlert({ type: "info", message: `${responseApi.message}. Realiza tu corte para continuar`, timeout: 10000 });
                    await this.setState({
                        idWorkShift: responseApi.data.idSession,
                        lastDaySession: true,
                    });
                    await this.ShowCashCutModal();
                    $("#cashCutModal").modal("show");
                } else {
                    this.setState({ idWorkShift: responseApi.data.idSession });
                }
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    ShowCashCutModal = async () => {
        await this.setState({
            showCashCutModal: !this.state.showCashCutModal,
        });
        if (this.state.showCashCutModal) await this.GetBoxCut();
    };

    GetBoxCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        enableSpinner(true);
        let responseApi = await apiClient.partialCut(idWorkShift);

        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        await this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            TotalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries
        });
    };

    ShowInitialCash = async () => {
        await this.setState({
            showInitialCashModal: !this.state.showInitialCashModal,
        });

        $("#initialCashModal").modal("show");
    };

    DeterminatePayWithTerminalPermission = async () => {
        const { _user } = this.state
        let flag = false;
        if (_user?.M_user !== "" || _user?.M_pass !== "") {
            flag = true;
        }

        await this.setState({
            FlagPayWithSantander: flag
        })
    }

    searchBanksOptions = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }
    }

    //FROM POSVIEW
    SearchReserveInvoiceDoc = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state
        const infoByFolio = await _generalFunctions.getDocInfoByFolio(newOrderModel.NumAtCard);

        if (newOrderModel.NumAtCard === '' || infoByFolio.folioID !== 'IV') {
            showAlert({ type: "info", message: `Ingresa un folio de factura de reserva valido. ` });
            return;
        }
        const data = {
            Folio: newOrderModel.NumAtCard || '',
            infoByFolio
        }

        enableSpinner(true);
        const responseApi = await apiClient.SearchReserveInvoiceDoc(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            await this.ReturnToOrigin();
            return;
        }
        if ((!responseApi.data.headerDocument || responseApi.data.headerDocument === null) || (!responseApi.data.docLines || responseApi.data.docLines.length === 0)) return;
        const newOrder = await this.FillInfoReserveInvoice(responseApi.data, true);
        await this.setState({
            newOrderModel: newOrder,
        })
    }

    ReturnToOrigin = async () => {
        await this.setState({
            checkboxDataTables: (new Map()),
        });
        await this.SetDefaultPartner();
        await this.CheckWorkSession();
        await this.SetBranchOfficeInfo();
        await this.SetCounterPermissions();

    }

    FillInfoReserveInvoice = async (infoData, needRelation) => {
        const { notificationReducer: { showAlert } } = this.props;
        let anotherOrderModel = new NewOrderSales();

        // Advertencia de socio de negocio inactivo
        if (infoData.headerDocument.validFor && infoData.headerDocument.validFor === 'N') {
            showAlert({ type: "warning", message: `El socio de negocios se encuentra inactivo, solicite habilitarlo para continuar` });
        }

        // const infoFolio = await _generalFunctions.getDocInfoByFolio(infoData.headerDocument.NumAtCard);
        anotherOrderModel.CardCode = infoData.headerDocument.CardCode;
        anotherOrderModel.NumAtCard = infoData.headerDocument.NumAtCard;
        anotherOrderModel.CardName = infoData.headerDocument.CardName;
        anotherOrderModel.Comments = '';
        anotherOrderModel.Comments = '';
        anotherOrderModel.ObjType = 'deliveries'
        anotherOrderModel.ReserveDelivery = true;
        anotherOrderModel.NextFolio = infoData.headerDocument.NumAtCard;

        for (let i = 0; i < infoData.docLines.length; i++) {
            const ItemRes = infoData.docLines[i];
            let newItemModel = new NewItem();
            if (needRelation) {
                newItemModel.BaseEntry = infoData.headerDocument.DocEntry || '';
                newItemModel.BaseType = 13;
                newItemModel.BaseLine = ItemRes.LineNum;
            }
            newItemModel.LineStatus = ItemRes.LineStatus === 'O' ? true : false;
            newItemModel.LineNum = ItemRes.LineNum;
            newItemModel.ItemCode = ItemRes.ItemCode;
            newItemModel.ItemName = ItemRes.ItemName || ItemRes.Dscription;
            newItemModel.Description = ItemRes.Dscription
            newItemModel.UserText = ItemRes.UserText;
            newItemModel.CodeBars = ItemRes.CodeBars || "";
            newItemModel.HomePrice = Number(ItemRes.Price);
            newItemModel.Price = Number(ItemRes.Price);
            newItemModel.Total = Number(ItemRes.LineTotal)
            newItemModel.TaxCode = ItemRes.TaxCode;
            newItemModel.TaxRate = ItemRes.Impuesto;
            newItemModel.NumInSale = Number(ItemRes.NumInSale || 0);
            newItemModel.OnHand = Number(ItemRes.OnHand || 0);
            newItemModel.Quantity = Number(ItemRes.Quantity || 1);
            newItemModel.newQuantity = Number(ItemRes.OpenQty || 1);
            newItemModel.RevenuesAc = ItemRes.RevenuesAc;
            newItemModel.SWeight1 = Number(ItemRes.SWeight1 || 0);
            newItemModel.SWght1Unit = ItemRes.SWght1Unit || 3;
            newItemModel.InvntItem = ItemRes.InvntItem || 'Y';
            newItemModel.ManBtchNum = ItemRes.ManBtchNum || 'M';
            newItemModel.OpenQty = ItemRes.OpenQty ? ItemRes.OpenQty : 0;
            newItemModel.AvgPrice = ItemRes.AvgPrice || 0;
            newItemModel.WhsStock = ItemRes.WhsStock || 0;
            newItemModel.WhsCode = ItemRes.WhsCode || '';
            if (ItemRes.BatchNumbers) {
                newItemModel.BatchNumbers = ItemRes.BatchNumbers ?? [];
            }
            anotherOrderModel.Items.push(newItemModel);
        }
        return anotherOrderModel;
    }

    SetDefaultPartner = async () => {
        const { _user, newOrderModel } = this.state;
        const partner = _user.Partner;

        // newOrderModel.CardCode = partner.CardCode;
        // newOrderModel.TaxCode = partner.TaxCode;
        // newOrderModel.TaxName = partner.TaxName;
        // newOrderModel.TaxRate = partner.Rate;
        // newOrderModel.PriceListNum = partner.ListNum;
        // newOrderModel.ShipToDef = partner.ShipToDef;
        // newOrderModel.BillToDef = partner.BillToDef;
        // newOrderModel.LicTradNum = partner.LicTradNum;
        // newOrderModel.SlpCode = partner.SlpCode;
        // newOrderModel.U_FMB_USO_CFDI = partner.U_FMB_USO_CFDI || '';


        await this.setState({
            newOrderModel
        });
    }

    SetBranchOfficeInfo = async () => {
        const { _user, newOrderModel } = this.state
        const auxArrayMethods = _user.Branch.PaymentMethods.slice() || [];
        const indexNC = auxArrayMethods.findIndex(object => { return object.code === 'NC'; });
        if (indexNC !== -1) auxArrayMethods.splice(indexNC, 1);

        const indexCD = auxArrayMethods.findIndex(object => { return object.code === 'CD'; });
        if (indexCD !== -1) auxArrayMethods.splice(indexCD, 1);

        await this.setState({
            LimitLinesBO: _user?.Branch.LimitLines || 0,
            CounterRol: _user?.U_FMB_CounterRol || null,
            AvailablePayments: auxArrayMethods || [],
            creditNotesPay: indexNC !== -1 ? true : false,
            creditPay: indexCD !== -1 ? true : false
        })

        if (_user?.U_FMB_CounterRol === 'storer') {
            await this.ChangeObjectype(this.state.newOrderModel, 'quotations', false);
        }
        if (_user?.U_FMB_CounterRol === 'counter') {
            await this.ChangeObjectype(this.state.newOrderModel, 'deliveries2', false);
        }
        await this.SetBranchOfficeTaxes(newOrderModel);
    }

    SetCounterPermissions = () => {
        const { _user } = this.state
        this.setState({
            EditDiscount: _user?.CounterPermission.EditDiscount || false,
            EditPrice: _user?.CounterPermission.EditPrice || false
        })
    }

    ChangeObjectype = async (newOrderModel, value, requireInvoice) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state;
        newOrderModel.ObjType = value;
        if (value !== 'deliveries' && value !== 'deliveries2') {
            newOrderModel.DeliveryAuthorization = 'N'
        }
        // let serieCode = '';
        await this.setState({ objType: value })
        if (value === 'deliveries' || value === 'deliveries2' || value === 'deliveries4' || value === 'directDelivery') {
            if (!requireInvoice) {
                newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesODLN');
            } else {
                newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesOINV');
            }
        } else if (value === 'quotations') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesOQUT');
        } else if (value === 'orderSales') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesORDR');
        } else if (value === 'invoiceReserve') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesOINV');
        } else if (value === 'creditNote') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesORIN');
        } else if (value === 'downPayments') {
            if (!_user?.U_FMB_ValidateSeriesODPI || _user?.U_FMB_ValidateSeriesODPI === '' || _user?.U_FMB_ValidateSeriesODPI === undefined || _user?.U_FMB_ValidateSeriesODPI === null) {
                showAlert({ type: "warning", message: "TU SUCURSAL ASIGNADA NO CUENTA CON SERIES PARA FACTURAS DE ANTICIPO NOTIFIQUE A SU MANAGER", timeOut: 5000 });
            }
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesODPI');
            newOrderModel.Items = [];
            await this.setState({ itemSearch: Anticipo?.[0] ?? '' })
            await this.SearchItems();
        }
        this.setState({
            newOrderModel,
            requireInvoice,
        });
    }

    SetBranchOfficeTaxes = async newOrderModel => {
        const { enableSpinner } = this.props;
        const { _user, taxList } = this.state
        let auxTaxList = [];

        if (taxList && Array.isArray(taxList) && taxList.length > 0) {
            auxTaxList = taxList;
        } else {

            enableSpinner(true);
            const getTaxesResponse = await apiClient.getTaxesList('AR');
            enableSpinner(false);
            auxTaxList = getTaxesResponse.data || [];
        }

        let auxTaxes = [];
        if (auxTaxList.length > 0 && _user?.Branch.IsBorder !== '') {
            if (_user?.Branch.IsBorder === 'Y') { // si eres frontera
                // I did that because not everybody afiliate with 8% tax in border
                // auxTaxes = await auxTaxList.filter((element) => Number(element.Rate) !== 16);
            } else if (_user?.Branch.IsBorder === 'N') { // si no eres frontera
                auxTaxes = await auxTaxList.filter((element) => Number(element.Rate) !== 8);
            }
        }
        const findAttribute = _user?.Branch.IsBorder === 'Y' ? 8 : 16;
        const arrayToFind = auxTaxes.length === 0 ? auxTaxList : auxTaxes;
        const findTaxElement = await arrayToFind.find((element) => Number(element.Rate) === findAttribute)

        if (findTaxElement) {
            newOrderModel.TaxCode = findTaxElement.Code;
            newOrderModel.TaxRate = Number(findTaxElement.Rate);
            newOrderModel.TaxName = findTaxElement.Name || '';
        }
        await this.setState({
            newOrderModel,
            taxList: auxTaxes.length === 0 ? auxTaxList : auxTaxes
        })
    }

    GetSeriesByCurrentUserProp = async (nameProperty) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        if (!_user?.hasOwnProperty(`${nameProperty}`)) {
            return null
        }
        const seriesDocument = _user[nameProperty];
        if (seriesDocument) {
            enableSpinner(true);
            const serieResponse = await apiClient.validateSerialNumbers({ seriesDocument });
            enableSpinner(false);
            if (serieResponse.status === SERVICE_RESPONSE.SUCCESS) {
                return serieResponse.data;
            } else {
                showAlert({ type: "warning", message: serieResponse.message, timeOut: 5000 });
                return null;
            }
        } else {
            return null
        }
    }

    SearchItems = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { itemSearch, newOrderModel, objType } = this.state;
        if (!itemSearch || itemSearch.length < 3) {
            showAlert({ type: "warning", message: "Producto no encontrado" });
            await this.setState({
                suggestions: [],
            });
            return;
        }

        const data = {
            ItemCode: itemSearch,
            CardCode: newOrderModel.CardCode || "",
            objType: objType,
            PriceListNum: newOrderModel.PriceListNum || '',
        };

        enableSpinner(true);
        const getItemsResponse = await apiClient.SearchItems(data);
        enableSpinner(false);
        if (!Array.isArray(getItemsResponse.data)) {
            showAlert({ type: "error", message: getItemsResponse.message });
            return;
        }

        if (getItemsResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }

        let itemList = getItemsResponse.data || [];

        if (itemList.length === 1) {
            await this.AddItem(itemList[0]);
        } else {
            await this.setState({
                suggestions: itemList,
                suggestionsCopy: itemList,
                ShowWithStock: false,
                showSearchModal: true,
            });
            $("#searchModal").modal("show");
        }
    };

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id));
            return { checkboxDataTables };
        });
    }

    toggleDocumentSelectedAll = (action) => {
        const { newOrderModel } = this.state;
        let newCheckbox = (new Map());

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const register = newOrderModel.Items[index];
            if (Number(register.OpenQty) !== 0) {
                newCheckbox.set(index, action)
            }
        }

        this.setState({
            checkboxDataTables: newCheckbox
        });
    }

    MakeReserveDelivery = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, checkboxDataTables, idWorkShift, _user } = this.state
        let ItemsToDeliver = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                ItemsToDeliver.push(newOrderModel.Items[id]);
            }
        }
        if (ItemsToDeliver.length === 0) {
            showAlert({ type: 'warning', message: 'No has seleccionado ninguna linea a entregar', timeOut: 1000 });
            return;
        }

        let serieCode = _user?.U_FMB_ValidateSeriesODLN.split("|");

        for (let index = 0; index < serieCode.length; index++) {
            const serie = serieCode[index];
            if (index === 0) {
                newOrderModel.SerieCode = serie;
                break;
            }
        }

        for (let x = 0; x < ItemsToDeliver.length; x++) {
            const item = ItemsToDeliver[x];
            if (Number(item.newQuantity) === 0) {
                showAlert({ type: 'warning', message: 'No puedes crear entregas de 0 unidades', timeOut: 1000 });
                return;
            }
            item.Quantity = Number(item.newQuantity);
        }

        newOrderModel.Items = ItemsToDeliver;
        const table = this.selectTable(newOrderModel.ObjType);
        newOrderModel.idSession = idWorkShift;
        newOrderModel.OriginDoc = 'Counter-MakeReserveDelivery';
        await this.toggleDocumentSelectedAll(true);
        const batchValidation = await this.ValidateBatchToDelivery();
        if (!batchValidation) {
            showAlert({ type: 'info', message: 'Seleccione los lotes correspondientes a cada artículo', timeOut: 1000 });
            return;
        }

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: newOrderModel,
            Time: moment().format(),
            UserTime: moment().format("HH:mm:ss"),
            ClientVersion: currentVersion,
        };

        enableSpinner(true);
        const createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud, " + createDocumentResponse.message, timeOut: 5000 });
            return;
        } else if (createDocumentResponse.status === 8) {
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 50000 });
            $('#newUpdateModal').modal('show');
            return
        }

        const createdDoc = createDocumentResponse.data;
        showAlert({ type: "success", message: "Entrega realizada con exito " + createdDoc.createdFolio, timeOut: 5000 });

        newOrderModel.Total = createDocumentResponse.data.serviceLayeResponse.DocTotal;
        newOrderModel.folio = createDocumentResponse.data.createdFolio;
        newOrderModel.DocTime = data.UserTime || createDocumentResponse.data.serviceLayeResponse.DocTime;

        newOrderModel.CardCode = createDocumentResponse.data.serviceLayeResponse.CardCode;
        newOrderModel.CardName = createDocumentResponse.data.serviceLayeResponse.CardName;
        newOrderModel.LicTradNum = createDocumentResponse.data.serviceLayeResponse.FederalTaxID;
        newOrderModel.Comments = createDocumentResponse.data.serviceLayeResponse.Comments;
        newOrderModel.Address = createDocumentResponse.data.serviceLayeResponse.Address;
        newOrderModel.Address2 = createDocumentResponse.data.serviceLayeResponse.Address2;
        // newOrderModel.Items = createDocumentResponse.data.serviceLayeResponse.DocumentLines;

        // let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        await this.ShowCreatedReserveDelivery(newOrderModel.folio);
        await this.setState({ showBillModal: true });
    }

    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        let reserveInvoice = "N";

        switch (view) {
            case "quotations":
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                reserveInvoice = "N";
                break;
            case "orderSales":
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                reserveInvoice = "N";
                break;
            case "deliveries":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries2":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries3":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "invoice":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "invoiceReserve":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "Y";
                break;
            case "return":
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                reserveInvoice = "N";
                break;
            case "debitNote":
                name = "OINV";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "creditNote":
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                reserveInvoice = "N";
                break;
            case "downPayments":
                name = "ODPI";
                complement = "DPI1";
                docSubType = "--";
                docType = "203";
                reserveInvoice = "N";
                break;
            case "PurchaseOrder":
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case "purchaseReturn":
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case "GoodsReceipt":
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;
            case "PurchaseRequest":
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;
            case "purchaseInvoice":
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case "purchaseCreditNotes":
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;




            case "transfers":
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case "transfersRequest":
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case "transfersEntry":
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case "transfersOutput":
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case "bussinesPartner":
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case "inventoryRevaluation":
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case "payment":
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case "outgoingPayment":
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "30";
                break;
            case "invoiceBorrador":
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case "invoiceAuthorization":
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;

            case "deliveries4":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;


            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return {
            name,
            complement,
            docSubType,
            docType,
            name2,
            complement2,
            docSubType2,
            docType2,
            reserveInvoice,
        };
    };

    ValidateBatchToDelivery = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
        if (itemsBatch.length > 0) {
            let isBatchComplete = true;
            for (let index = 0; index < itemsBatch.length; index++) {
                const item = itemsBatch[index];
                item.SnBUoMQty = 0;
                item.BatchNumbers.map((batch) => { item.SnBUoMQty += Number(batch.Quantity); });
                item.OpenLneQty = Number(item.Quantity) - Number(item.SnBUoMQty);
                if (Number(item.SnBUoMQty) !== Number(item.Quantity)) { isBatchComplete = false; }
            }
            if (!isBatchComplete) {
                let newItemsBatchArray = []
                itemsBatch.map(item => { newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode }) })

                enableSpinner(true);
                let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                enableSpinner(false);

                if (batchsResponse.status === 0) {
                    showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                    return;
                }
                let isNewBatch = false;
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];
                    for (let index = 0; index < batchsResponse.data.length; index++) {
                        const itemBatch = batchsResponse.data[index];
                        if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                            if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) { isNewBatch = true; }
                            item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                        }
                    }
                }

                if (isNewBatch) {
                    await this.setState({
                        newOrderModel,
                        showBatchSelectionModal: true,
                    });
                    $('#batchSelectionModal').modal('show');
                } else {
                    showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                }
                return false;
            }
        }
        return true;
    }

    ShowCreatedReserveDelivery = async (document) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            docsToPrintIds: [document],
            typeDoc: 15
        }
        enableSpinner(true);
        const responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ERDR',
            ordersToAction: document,
            EnableEditButton: false,
            showPDFViewer: !this.state.showPDFViewer,
            ShowExtraActions: false,
            checkboxDataTables: (new Map()),
        });
        $("#pdfViewer").modal("show");

    }
    ChangeFolio = (value) => {
        const { newOrderModel } = this.state
        newOrderModel.NumAtCard = value;
        this.RefreshOrder(newOrderModel);
    }
    RefreshOrder = async (newOrderModel) => {
        await this.setState({ newOrderModel });
    };

    IsInteger(num) {
        if (num % 1 == 0) {
            return true
        } else {
            return false
        }
    }

    ChangeQuantityDelivery = async (index, item, event) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let newQuantity = event.nativeEvent.target.value;
        if (Number(newQuantity) > Number(item.OpenQty)) {
            newQuantity = Number(item.OpenQty);
            newOrderModel.Items[index].newQuantity = newQuantity;
            newOrderModel.Items[index].BatchNumbers = [];
            this.RefreshOrder(newOrderModel);
            showAlert({ type: 'warning', message: 'No puedes devolver mas unidades de las visibles', timeOut: 0 });
            return;
        } else {
            if (Number(newQuantity) <= Number(item.OpenQty) && Number(newQuantity) >= 0) {
                newOrderModel.Items[index].newQuantity = newQuantity;
                newOrderModel.Items[index].BatchNumbers = [];
                this.RefreshOrder(newOrderModel);
            }
        }


    }

    ChangeComments = (value) => {
        const { newOrderModel } = this.state
        newOrderModel.Comments = value;
        this.RefreshOrder(newOrderModel);
    }
    ChangeInitialDate = async (event) => {
        let initialDate = event.nativeEvent.target.value;
        await this.setState({
            initialDate,
        });
    };
    ChangeFinalDate = async (event) => {
        const { initialDate } = this.state;
        let finalDate = event.nativeEvent.target.value;
        if (finalDate < initialDate) {
            return;
        }
        await this.setState({
            finalDate,
        });
    };
    RefreshSearchOrdersModel = (ordersSearchModel) => {
        this.setState({ ordersSearchModel })
    }

    ShowPDFViewer = async () => {
        await this.setState({
            showPDFViewer: !this.state.showPDFViewer,
        });
        // this.CloseBillModal()
    };
    CloseRefundModal = async () => {
        let { newOrderModel, _user } = this.state;
        let partner = _user?.Partner;
        newOrderModel.TotalRestante = 0;

        newOrderModel = new NewOrderSales();
        newOrderModel.TaxCode = partner.TaxCode;
        newOrderModel.TaxName = partner.TaxName;
        newOrderModel.TaxRate = partner.Rate;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.PriceListNum = partner.ListNum;
        newOrderModel.ShipToDef = partner.ShipToDef;
        newOrderModel.BillToDef = partner.BillToDef;

        await this.setState({
            newOrderModel,
            showRefundModal: false,
            itemSelected: {},
            pedido: '',
            itsCancelCFDIAvailable: false,
            relatedDocs: [],
        });
        await this.CheckWorkSession();
        await this.SetBranchOfficeInfo();
        await this.SetCounterPermissions();
    };

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        // var value = docsStruct.innerHTML;
        // var objToSend = JSON.stringify(value);
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? '')
        sendMailModel.docEntry = infoFolio.DocEntry
        let data = {
            sendMailModel,
            // docsStruct: objToSend,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? '',
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? '',
                slpInfo: {
                    slpCode: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpCode : docsToPrint[0].docHeader.SlpCode || '',
                    slpName: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpName : docsToPrint[0].docHeader.SlpName || '',
                }
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    ShowNextDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { extraDocsToShow, indexTypeDocShow } = this.state;

        let indexDoc = indexTypeDocShow + 1;
        if (indexDoc === extraDocsToShow.length) {
            indexDoc = 0; // back to origin
        }

        const data = {
            docsToPrintIds: [extraDocsToShow[indexDoc].Folio],
            typeDoc: extraDocsToShow[indexDoc].DocObjectType
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        for (let index = 0; index < responseApi.data.length; index++) {
            const document = responseApi.data[index];
            if (extraDocsToShow[indexDoc].timbraResponse && index === 0 && extraDocsToShow[indexDoc].timbraResponse.status) {
                if (extraDocsToShow[indexDoc].timbraResponse && index === 0 && extraDocsToShow[indexDoc].timbraResponse.status) {
                    // showAlert({ type: "success", message: `${extraDocsToShow[indexDoc].timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(extraDocsToShow[indexDoc].timbraResponse.XML);
                } else if (extraDocsToShow[indexDoc].timbraResponse && !extraDocsToShow[indexDoc].timbraResponse.status) {
                } else if (extraDocsToShow[indexDoc].timbraResponse && !extraDocsToShow[indexDoc].timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${extraDocsToShow[indexDoc].timbraResponse.message}`, timeOut: 10000 });
                }
            }
            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: extraDocsToShow[indexDoc].TypeDoc,
                EnableEditButton: false,
                indexTypeDocShow: indexDoc
            });
        }
    }

    RefreshDocModel = async (EditableDocModel) => {
        await this.setState({ EditableDocModel })
    }

    UploadInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ordersToAction, idWorkShift, pedido, newOrderModel } = this.state

        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido)
        let data = {
            ordersToAction,
            infoFolio,
            idWorkShift,
            newOrderModel,
            Folio: pedido,
            Time: moment().format(),
        }

        enableSpinner(true);
        let responseApi = await apiClient.createInvoiceCounter(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message}`, timeOut: 10000 });
        await this.CloseRefundModal()
        $("#salesModal").modal("hide");
        await this.ShowCreatedInvoice(responseApi.data.createdFolio, false, responseApi.data.timbraResponse);
    }

    ShowCreatedInvoice = async (document, beforeEdit, timbraResponse = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!beforeEdit) {
            const data = {
                docsToPrintIds: [document],
                typeDoc: 13
            }
            enableSpinner(true);
            const responseApi = await apiClient.getPrintDocsInfo(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                this.CloseCreatedInvoiceActions();
                return;
            }

            for (let index = 0; index < responseApi.data.length; index++) {
                const document = responseApi.data[index];
                if (timbraResponse && index === 0 && timbraResponse.status) {
                    showAlert({ type: "success", message: `${timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(timbraResponse.XML);
                } else if (timbraResponse && !timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${timbraResponse.message}`, timeOut: 10000 });
                }
            }

            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: 'OINV',
                ordersToAction: document,
                EnableEditButton: false,
                showPDFViewer: !this.state.showPDFViewer,
                ShowExtraActions: timbraResponse && timbraResponse.status ? true : false
            });

            $("#pdfViewer").modal("show");
        } else {
            await this.setState({
                docsToPrint: [document] ?? [],
                typeDocPrint: 'OINV',
                ordersToAction: ''
            });
            await this.ShowPDFViewer();
            $("#pdfViewer").modal("show");
        }
    }

    CloseCreatedInvoiceActions = async () => {
        let { newOrderModel, isCancel, _user, PointsCardModel } = this.state;
        let partner = _user?.Partner;
        newOrderModel = new NewOrderSales();
        // newOrderModel.TaxCode = partner.TaxCode;
        // newOrderModel.TaxName = partner.TaxName;
        // newOrderModel.TaxRate = partner.Rate;
        // newOrderModel.CardCode = partner.CardCode;
        // newOrderModel.CardName = partner.CardName;
        // newOrderModel.PriceListNum = partner.ListNum;
        // newOrderModel.ShipToDef = partner.ShipToDef;
        // newOrderModel.BillToDef = partner.BillToDef;
        newOrderModel.ObjType = 'deliveries';

        await this.ShowPDFViewer();
        await this.setState({
            newOrderModel,
            docsToPrint: [],
            typeDocPrint: '',
            ordersToAction: 0,
            requireInvoice: false,
            itemSelected: {},
            showBillModal: isCancel || !this.state.showBillModal,
            extraDocsToShow: [],
            indexTypeDocShow: 0,
            ShowExtraActions: false
        })
        await this.SetBranchOfficeInfo();
        await this.SetCounterPermissions();
        await this.SetDefaultPartner();
        if (PointsCardModel && PointsCardModel.Customer && PointsCardModel.Customer.LostPoints && points_Card) {
            await this.setState({
                showAreYouAgreeModal_Join_e_Wallet: !this.state.showAreYouAgreeModal_Join_e_Wallet,
            });
            $('#areYouAgreeModal').modal('show');
        }
    };

    Add_To_PointsCard = async () => {
        await this.setState({
            showNewCustomerModal: !this.state.showNewCustomerModal,
        });
        $("#newCustomer").modal("show");
    };

    CloseShowAreYouAgreeModal_Join_e_Wallet = async () => {
        await this.setState({
            showAreYouAgreeModal_Join_e_Wallet: false,
            PointsCardModel: new PointsCardModel(),
        });
    };

    change_U_FMB_Handel_Email = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;

        let value = event.nativeEvent.target.value;
        if (value.length > 100) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida.' });
        }
        PointsCardModel.Customer.U_FMB_Handel_Email = value;
        this.setState({
            PointsCardModel,
        })
    };

    change_U_FMB_Cellular = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;

        let value = event.nativeEvent.target.value;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Solo se permiten números.' });
            return
        }
        if (value.length > 20) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida.' });
        }
        PointsCardModel.Customer.U_FMB_Cellular = value;
        this.setState({
            PointsCardModel,
        })
    };

    sendNewCustomer = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        if (!PointsCardModel.Customer.U_FMB_Handel_Email) {
            showAlert({ type: "warning", message: "Es necesario registrar un correo electrónico.", timeOut: 5000 });
            return;
        };

        if (!EMAIL_FORMAT_REGEX.test(PointsCardModel.Customer.U_FMB_Handel_Email)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });

        if (!PointsCardModel.Customer.U_FMB_Cellular) {
            showAlert({ type: "warning", message: "Es necesario registrar un número de teléfono.", timeOut: 5000 });
            return;
        };

        if (PointsCardModel.Customer.U_FMB_Cellular.length < 10) {
            showAlert({ type: "warning", message: "El número de teléfono debe de incluir al menos 10 caracteres.", timeOut: 5000 });
            return;
        };

        enableSpinner(true);
        let data = {
            Customer: PointsCardModel.Customer,
        }
        let response_NewCustomerPointsCard = await apiClient.NewCustomerPointsCard(data);

        if (response_NewCustomerPointsCard.status !== 1) {
            showAlert({ type: "error", message: `${response_NewCustomerPointsCard.message}` });
            enableSpinner(false);
            return;
        }
        showAlert({ type: "success", message: `${response_NewCustomerPointsCard.message}` });
        $("#newCustomer").modal("hide");
        await this.setState({
            showAreYouAgreeModal_Join_e_Wallet: false,
            showNewCustomerModal: false,
            PointsCardModel: new PointsCardModel(),
        });
        $("#newCustomer").modal("hide");
        enableSpinner(false);
    };

    CloseWorkShift = async (blindInfoModel) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        const data = {
            idWorkShift,
            blindInfoModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.closeWorkShiftT(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return false;
        }

        showAlert({ type: "info", message: `${responseApi.message}` });
        $("#totalModal").modal("show");
        await this.setState({
            lastDaySession: false,
            ReturnedBlindCut: responseApi.ReturnedBlindCut || [],
        })
        return true;
    };

    SendToLogin = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        showAlert({ type: "info", message: `ESTAS SIENDO REDIRIGIDO AL LOGIN. ESTO ES PLANEADO.`, timeOut: 99999 });
        localStorage.removeItem(config.localStorageNamed + 'Token');
        localStorage.removeItem(config.localStorageNamed + 'currentUser');
        localStorage.removeItem(config.localStorageNamed + 'toogleNavBarItem');
        // const existStorage = localStorage.getItem(config.localStorageNamed + 'currentUser');
        socketService.emit('logout', '');
        this.props.history.push('/');
        this.props.history.push('/login');
        window.location.reload(true);

    }

    ShowBlindCashCut = async () => {
        await this.setState({
            blindCashCut: !this.state.blindCashCut,
        });
    };

    InsertWorkShiftT = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.insertWorkShiftT();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        if (responseApi.status === 0) {
            await this.GotoDashboard();
        }
        this.setState({ idWorkShift: responseApi.data.idSession });
    };

    CancelWorkShift = () => {
        this.GotoDashboard();
    };

    GotoDashboard = () => {
        this.props.history.push("/");
    };

    ShowBatchSelectionModal = async (nextStep) => {
        // const { enableSpinner } = this.props;
        // const { disableRecover, newOrderModel } = this.state;
        if (nextStep) {
            const isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                await this.setState({
                    showBatchSelectionModal: !this.state.showBatchSelectionModal,
                });
                //is never used here
                // if (newOrderModel.ObjType === 'deliveries') {
                //     await this.ShowBillModal();
                //     if (await this.CheckIfItsUniversalPartner() === true) {
                //         $("#billModal").modal("show");
                //     } else {
                //         if (disableRecover) {
                //             $("#billModal").modal("show");
                //         } else {
                //             $("#vmInvoice").modal("show");
                //         }
                //     }
                // } else if (newOrderModel.ObjType === 'deliveries2') {
                //     if (await this.CheckIfItsUniversalPartner()) {
                //         enableSpinner(true);
                //         let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                //         this.GetPartnerAddresses(newOrderModel.CardCode);
                //         newOrderModel.DeliveryAuthorization = 'I';
                //         await this.refreshModel(newOrderModel)
                //         enableSpinner(false);
                //         await this.setState({
                //             updatebusinessPartner: getPartnersResponse.data[0],
                //             NextStepFunction: async () => {
                //                 $('#detailClientModal').modal('hide');
                //                 const isAuthorization = await this.ValidateAuthorization();
                //                 if (!isAuthorization) { this.CreateDocument(); }
                //             },
                //             ContinueWithoutSave: async () => {
                //                 $('#detailClientModal').modal('hide');
                //                 let isAuthorization = await this.ValidateAuthorization();
                //                 if (!isAuthorization) { this.CreateDocument(); }
                //             }
                //         });
                //         $("#detailClientModal").modal("show");
                //     } else {
                //         await this.ShowBillModal();
                //         $("#vmInvoice").modal("show");
                //     }
                // }
            }

        } else {
            await this.setState({
                showBatchSelectionModal: !this.state.showBatchSelectionModal,
            });
        }
    };

    refreshModel = async newOrderModel => {
        await this.setState({
            newOrderModel
        })
    };



    ValidateAuthorization = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, idWorkShift, requireInvoice } = this.state;

        if (newOrderModel.isDocumentWithAuthorization) {
            return false;
        }

        if (!newOrderModel.Items.length) {
            showAlert({ type: "warning", message: "Documento sin artículos", timeOut: 2000 });
            return;
        }

        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const DocItem = newOrderModel.Items[i];
            if (DocItem.Quantity === '' || DocItem.Quantity === 0) {
                newOrderModel.Items[i].Quantity = 1;
            }
        }
        this.FillDataFromPartner();

        let table = this.selectTable(requireInvoice ? 'invoice' : newOrderModel.ObjType);
        newOrderModel.idSession = idWorkShift;

        await this.IsPayedByDownPayment();

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            model: newOrderModel,
        };

        enableSpinner(true);
        const response = await apiClient.autorizationModels(data);
        enableSpinner(false);

        let autorization = [];
        if (response.status === 1) {
            let respo = response.autorization;
            for (let i = 0; i < respo.length; i++) {
                const element = respo[i];
                autorization.push({
                    name: element.nameCond,
                    id: element.wtm,
                    comment: '',
                });
            }

            let autho = {};
            autorization = autorization.filter((element) => autho[element.id] ? false : autho[element.id] = true);
            this.setState({
                AuthorizationComments: autorization,
            });

            // if(!isUniversal && requireInvoice && newOrderModel.ObjType === 'deliveries2'){
            //     $('#authorizationModel').modal('false');
            // }else{
            //     $('#authorizationModel').modal('show');
            // }
            $('#authorizationModel').modal('show');
            return true;
        } else {
            return false;
        }
    }

    render() {
        const { notificationReducer: { showAlert } } = this.props;
        const { _user
            , newOrderModel
            , checkboxDataTables
            , showPDFViewer
            , docsToPrint
            , typeDocPrint
            , EnableEditButton
            , initialDate
            , finalDate
            , ordersSearchModel
            , ordersDocs
            , ordersToAction
            , editableMode
            , EditableDocModel
            , detailDoc
            , groupNumList
            , extraDocsToShow
            , sendMailModel
            , printhide
            , PointsCardModel
            , ShowExtraActions
            , showAreYouAgreeModal_Join_e_Wallet
            , showNewCustomerModal
            , showCashCutModal
            , cashCut
            , objCharge
            , totalCashCut
            , TotalAmountSales
            , numSalesCashCut
            , extraPaymentsCashCut
            , moneyEntries
            , moneyOuts
            , lastDaySession
            , blindCashCut
            , ReturnedBlindCut
            , showInitialCashModal
            , showBatchSelectionModal
            , bankOptions = []
        } = this.state

        let salesTools = {
            initialDate,
            finalDate,
            ordersSearchModel,
            ordersDocs,
            ordersToAction,
            showPDFViewer,
            docsToPrint,
            editableMode,
            EditableDocModel,
            detailDoc,
            groupNumList,
            ChangeInitialDate: this.ChangeInitialDate,
            ChangeFinalDate: this.ChangeFinalDate,
            RefreshSearchOrdersModel: this.RefreshSearchOrdersModel,
            // SearchOrders: this.SearchOrders,
            // GetDocFolio: this.GetDocFolio,
            // SendDocsToPdfViewer: this.SendDocsToPdfViewer,
            // ChangeEditableMode: this.ChangeEditableMode,
            RefreshDocModel: this.RefreshDocModel,
            // SaveChangesOrderInvoice: this.SaveChangesOrderInvoice,
            // ShowDocInfo: this.ShowDocInfo,
            // CloseDocument: this.CloseDocument,
            UploadInvoice: this.UploadInvoice,
            // CloseModalActions: this.CloseModalActions,
            ShowPDFViewer: () => {
                this.ShowPDFViewer();
                this.CloseRefundModal();
            },
        }

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }
        const mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'ENTREGAS'} url1={'#'} />
                {showInitialCashModal && (
                    <InitialCashModal
                        InsertWorkShiftT={this.InsertWorkShiftT}
                        CancelWorkShift={this.CancelWorkShift}
                    />
                )}
                {showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={typeDocPrint}
                        EnableEditButton={EnableEditButton}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditableDocModel={salesTools.EditableDocModel}
                        RefreshDocModel={salesTools.RefreshDocModel}
                        SaveChanges={this.SaveChangesInvoice}
                        UploadDoc={salesTools.UploadInvoice}
                        EditParam1={false}
                        ShowPDFViewer={this.CloseCreatedInvoiceActions}
                        CreateDocument={this.CreateDocument}
                        OpenMailModal={this.OpenSendMailModal}
                        ItsFirme={true}
                        user={_user}
                        Counter={true}
                        MailTools={mailTools}
                        ExtraDocsToShow={extraDocsToShow}
                        ShowNextDocument={this.ShowNextDocument}
                        ShowExtraActions={ShowExtraActions}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                        reprint={false}
                        PointsCardModel={PointsCardModel}
                    />
                }

                {showAreYouAgreeModal_Join_e_Wallet &&
                    <AreYouAgreeModal
                        mensaje={'¿Te gustaría pertenecer al monedero electrónico?'}
                        accept={this.Add_To_PointsCard}
                        cancel={this.CloseShowAreYouAgreeModal_Join_e_Wallet}
                    />
                }
                {showNewCustomerModal &&
                    <NewCustomerModal
                        PointsCardModel={PointsCardModel}
                        cleanData={() => this.setState({ showNewCustomerModal: !this.state.showNewCustomerModal })}
                        change_CardName={() => { }}
                        change_U_FMB_Handel_Email={this.change_U_FMB_Handel_Email}
                        change_U_FMB_Cellular={this.change_U_FMB_Cellular}
                        change_U_FMB_Handel_Pass={() => { }}

                        sendNewCustomer={this.sendNewCustomer}
                        activeShowAreYouAgree_Update={() => { }}
                        showAreYouAgreeModal_Update={false}
                        action={1}
                    />
                }

                {showCashCutModal && (
                    <CashCutModal
                        ShowCashCutModal={this.ShowCashCutModal}
                        CashCut={cashCut}
                        ObjCharge={objCharge}
                        TotalCashCut={totalCashCut}
                        TotalAmountSales={TotalAmountSales}
                        NumVentas={numSalesCashCut}
                        extraPaymentsCashCut={extraPaymentsCashCut}
                        moneyEntries={moneyEntries}
                        moneyOuts={moneyOuts}
                        headerCashCut={{ U_NAME: "", docUpdate: "", endSession: "" }}
                        BranchOfficeGeneralCut={() => { }}
                        CloseWorkShift={this.CloseWorkShift}
                        GotoDashboard={this.SendToLogin}
                        lastDaySession={lastDaySession}
                        _user={_user}
                        blindCashCut={blindCashCut}
                        ShowBlindCashCut={this.ShowBlindCashCut}
                        ReturnedBlindCut={ReturnedBlindCut}
                        BlindCutByIdSession={[]}
                        bankOptions={bankOptions}
                    />
                )}

                {showBatchSelectionModal &&
                    <BatchSelectionModal
                        newOrderModel={newOrderModel}
                        showAlert={showAlert}
                        ShowBatchSelectionModal={this.ShowBatchSelectionModal}
                        refreshModel={this.refreshModel}
                        CloseOpenRefundOfPaymentsModal={() => { }}//this.CloseOpenRefundOfPaymentsModal//FOR THIS VIEW IS NEVER USED}
                    />
                }

                <div style={{ marginLeft: "4rem" }}>
                    <div>

                        <div className="row m-3">
                            <h3 className="ml-4 mb-2 mt-3">ENTREGAS</h3>
                        </div>

                        <div className="container-fluid mt-3">
                            <div className="row">
                                <div className="col-md-12 responsive-row">
                                    <div className="row m-3">
                                        <div className="col-12 col-md-6 mb-2 responsive-row">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="basic-addon1">
                                                        <strong>
                                                            <span className="d-none d-lg-inline">Buscar </span>Fac. Reserva
                                                        </strong>
                                                    </span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Folio"
                                                    value={newOrderModel ? newOrderModel.NumAtCard : ''}
                                                    onChange={(event) => this.ChangeFolio(event.target.value)}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.SearchReserveInvoiceDoc();
                                                        }
                                                    }}
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        type="button"
                                                        className="input-group-text"
                                                        style={{ backgroundColor: 'transparent', color: '#a1a9b1' }}
                                                        onClick={() => this.SearchReserveInvoiceDoc()}
                                                    >
                                                        <i className="fas fa-search" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-12 col-md-6 mb-2'>

                                        </div>

                                        <div className="col-12 col-md-4 mb-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Cliente</strong></span>
                                                </div>
                                                <input type="text"
                                                    className="form-control"
                                                    value={newOrderModel ? newOrderModel.CardCode : ''}
                                                    disabled />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 mb-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Nombre</strong></span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={newOrderModel ? newOrderModel.CardName : ''}
                                                    disabled />
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-4 text-right mb-2'>

                                            <button
                                                type="button"
                                                className="btn btn-primary ml-2"
                                                onClick={() => this.MakeReserveDelivery()}
                                            >Entregar</button>

                                        </div>
                                    </div>

                                    <div className="row m-3">
                                        <div className="col-12 col-md-6 mb-2">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Comentarios</strong></span>
                                                </div>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    aria-label="With textarea"
                                                    value={newOrderModel ? newOrderModel.Comments : ''}
                                                    onChange={(event) => this.ChangeComments(event.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-3 mb-2"> </div>
                                        <div className="col-12 col-md-3 mb-2">
                                        </div>
                                    </div>

                                    <div className='card scrollTableRefound m-4' style={{ maxHeight: "560px" }}>
                                        <table className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" scope="col">
                                                        #
                                                    </th>
                                                    <th className="text-center" scope="col">
                                                        <input
                                                            type="checkbox"
                                                            style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                            id="CheckAll"
                                                            onChange={(event) => checkbox.selectAll(event.target.checked)}
                                                        />
                                                    </th>
                                                    <th className="text-center" scope="col">
                                                        Código
                                                    </th>
                                                    <th className="col-6 text-center" scope="col">
                                                        Nombre
                                                    </th>
                                                    <th className=" text-center" scope="col">
                                                        Cantidad
                                                    </th>
                                                    <th className="text-center" scope="col">
                                                        Precio U.
                                                    </th>
                                                    <th className="text-center" scope="col">
                                                        Stock
                                                    </th>

                                                </tr>

                                            </thead>
                                            <tbody>
                                                {newOrderModel.Items && newOrderModel.Items.length > 0 &&
                                                    newOrderModel.Items.map((item, index) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td className="text-center">
                                                                        <strong>{index + 1}</strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ minWidth: '100%', width: '15px', height: '15px' }}
                                                                            // disabled={parseInt(item.OpenQty) === 0 ? true : false}
                                                                            checked={!!checkbox.data.get(index)}
                                                                            onChange={() => checkbox.selectOne(index)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <strong>{item.ItemCode}</strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {item.ItemName}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {this.IsInteger(Number(item.OpenQty).toFixed(4)) ?
                                                                            <strong>{parseInt(item.OpenQty)} /
                                                                                <input
                                                                                    type="number"
                                                                                    min={0}
                                                                                    className="text-center input-cantidad"
                                                                                    max={parseInt(item.OpenQty)}
                                                                                    onChange={(event) => { this.ChangeQuantityDelivery(index, item, event) }}
                                                                                    value={item.newQuantity}
                                                                                />
                                                                            </strong>
                                                                            :
                                                                            <>
                                                                                <strong>{Number(item.OpenQty ?? 0).toFixed(4)}{" / "}</strong>
                                                                                <input
                                                                                    type="number"
                                                                                    className="text-center input-cantidad"
                                                                                    value={item.newQuantity ?? ''}
                                                                                    onChange={(event) => { this.ChangeQuantityDelivery(index, item, event) }}
                                                                                />

                                                                            </>

                                                                        }

                                                                    </td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(item.Price)}</td>
                                                                    <td className="text-center">{FORMAT_NUMBER.new(item.WhsStock)}</td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }



}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeliverView);
